// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__4V77n","buttonSizeS":"button_buttonSizeS__KSUWg","outlined":"button_outlined__cnjWp"};